<template>
  <v-row>
    <v-col
      cols="12"
      md="6"
    >
      <base-material-card icon="mdi-account-outline">
        <template v-slot:after-heading>
          <div class="title font-weight-light">
            <span class="body-1">Договор - </span>
            <v-spacer />
            <span class="body-2">{{ title }}
              <v-icon
                v-if="view && form.id!=null"
                @click="$router.push('/contract/change?id=' + form.id)"
              >mdi-pencil</v-icon>
              <v-icon
                v-if="change && form.id!=null"
                @click="$router.push('/contract/view?id=' + form.id)"
              >mdi-eye</v-icon>
            </span>
          </div>
        </template>
        <base-material-tabs color="warning">
          <v-tab
            v-for="(tab, i) in tabs"
            :key="i"
          >
            {{ tab }}
          </v-tab>
          <v-tab-item>
            <form>
              <v-row>
             <v-col cols="12" v-if="form.kind!=3">
              <v-select
                v-model="form.contract_agent"
                :items="select.clients.filter(a=>a.contract_agent)"
                label="Выберите представителя для подписания договора"
                item-value="id"
                @change="(a)=>check_user(a)"
                clearable
              >
                <template v-slot:selection="{item}">
                  <v-list>
                    <v-list-item-content>
                      <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list>
                </template>
                <template v-slot:item="{item}">
                  <v-list>
                    <v-list-item-content>
                      <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="form.insurer_agent"
                :items="select.clients.filter(a=>a.insurer_agent)"
                label="Выберите представителя для представления интересов в СК"
                item-value="id"
                @change="(a)=>check_user(a)"
                clearable
              >
                <template v-slot:selection="{item}">
                  <v-list>
                    <v-list-item-content>
                      <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list>
                </template>
                <template v-slot:item="{item}">
                  <v-list>
                    <v-list-item-content>
                      <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" v-if="form.kind==3">
              <v-select
                v-model="form.legal_agent"
                :items="select.clients.filter(a=>a.legal_agent)"
                label="Выбор пользователя, от имени которого заключается договор "
                item-value="id"
                clearable
              >
                <template v-slot:selection="{item}">
                  <v-list>
                    <v-list-item-content>
                      <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list>
                </template>
                <template v-slot:item="{item}">
                  <v-list>
                    <v-list-item-content>
                      <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list>
                </template>
              </v-select>
            </v-col>  
            <v-col cols="12">
              <v-select
                v-model="form.requisites"
                :items="select.requisites"
                label="Реквизиты Евроком"
              >
              </v-select>
            </v-col>  
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="form.date"
                    v-validate="'required'"
                    :error-messages="errors.collect('about.date')"
                    color="secondary"
                    data-vv-name="date"
                    type="date"
                    label="Дата договора"
                    prepend-icon="mdi-calendar"
                    validate-on-blur
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-select
                    v-model="form.kind"
                    :items="dict.kind"
                    color="secondary"
                    label="Вид договора"
                    prepend-icon="mdi-car"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
              </v-row>
              <v-row>
                 <v-col cols="12" md="12" v-if="$store.state.client && $store.state.client.cities">
                  <v-select
                    v-model="form.city"
                    v-validate="'required'"
                    color="secondary"
                    label="Город"
                    validate-on-blur
                    :items="$store.state.client.cities"
                  />
                </v-col>
              </v-row>
              <v-row v-if="form.kind == 3">
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="form.percent"
                    color="secondary"
                    label="Процент выплаты по договору"
                    type="number"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
               
              </v-row>
              <v-row v-if="form.kind!=3">
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="form.sum"
                    color="secondary"
                    label="Сумма договора"
                    prepend-icon="mdi-car"
                    type="number"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-select
                    v-model="form.insurer"
                    :items="dict.insurer"
                    color="secondary"
                    label="Страховая"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="form.type"
                    :items="dict.contract_type"
                    label="Тип оформления"
                    prepend-icon="mdi-car"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                 <v-col
                  cols="8"
                >
                  <v-text-field
                    v-model="form.protocol_number"
                    color="secondary"
                    label="Номер протокола"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col
                  cols="4"
                >
                  <v-text-field
                    v-model="form.protocol_date"
                    color="secondary"
                    label="Дата протокола"
                    type="date"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col
                  v-if="form.type==2"
                  cols="12"
                >
                  <v-select
                    v-model="form.former"
                    :items="dict.scheme_former"
                    color="secondary"
                    label="Составитель"
                    prepend-icon="mdi-car"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col
                  v-if="form.type==2"
                  cols="4"
                >
                  <v-text-field
                    v-model="form.scheme.series"
                    color="secondary"
                    label="Серия схемы"
                    prepend-icon="mdi-car"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col
                  v-if="form.type==2"
                  cols="8"
                >
                  <v-text-field
                    v-model="form.scheme.number"
                    color="secondary"
                    label="Номер"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col
                  v-if="form.type==2"
                  cols="12"
                >
                  <v-text-field
                    v-model="form.scheme.date"
                    color="secondary"
                    label="Дата составления"
                    prepend-icon="mdi-car"
                    type="date"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
              </v-row>
            </form>
          </v-tab-item>
          <v-tab-item>
            <form>
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="form.owner.surname"
                    v-validate="'required'"
                    color="secondary"
                    label="Фамилия"
                    prepend-icon="mdi-account"
                    validate-on-blur
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="form.owner.name"
                    v-validate="'required'"
                    color="secondary"
                    label="Имя"
                    prepend-icon="mdi-account"
                    validate-on-blur
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="form.owner.patronymic"
                    v-validate="'required'"
                    color="secondary"
                    label="Отчество"
                    prepend-icon="mdi-account"
                    validate-on-blur
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="form.owner.birthday"
                    color="secondary"
                    label="Дата рождения"
                    type="date"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="form.owner.phone"
                    color="secondary"
                    type="number"
                    label="Телефон"
                    :counter="11"
                    maxlength="11"
                    :rules="[(v) => /7\d{10}/.test(v) || 'Неверное значение']"
                    prepend-icon="mdi-face"
                    :mask="'+7(###)###-##-##'"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    v-model="form.owner.address"
                    v-validate="'required'"
                    color="secondary"
                    label="Адрес"
                    prepend-icon="mdi-home-account"
                    validate-on-blur
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
              </v-row>
            </form>
          </v-tab-item>
          <v-tab-item>
            <form>
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="form.owner.doc_type"
                    :items="dict.doc_type"
                    color="secondary"
                    label="Тип документа"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="form.owner.doc.series"
                    color="secondary"
                    label="Серия"
                    prepend-icon="mdi-car"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="form.owner.doc.number"
                    color="secondary"
                    label="Номер документа"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="form.owner.doc.date"
                    color="secondary"
                    label="Дата выдачи"
                    type="date"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="form.owner.doc.code"
                    color="secondary"
                    label="Код подразделения"
                    class="purple-input"
                    name="doc_code"
                    :disabled="view"
                    @input="doc_code_input"
                  />
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="form.owner.doc.from"
                    color="secondary"
                    label="Кем выдано"
                    class="purple-input"
                    name="doc_from"
                    :disabled="view"
                    @input="doc_from_input"
                  />
                </v-col>
              </v-row>
            </form>
          </v-tab-item>
          <v-tab-item>
            <form>
              <v-row>
                <v-col cols="8">
                  <v-text-field
                    v-model="form.owner.requisites.bank_name"
                    name="bank_name"
                    color="secondary"
                    label="Банк"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="form.owner.requisites.bic"
                    name="bank_bic"
                    color="secondary"
                    label="Бик"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.owner.requisites.ks"
                    color="secondary"
                    label="К/с"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.owner.requisites.rs"
                    :counter="20"
                    :rules="[(v) => validateRs() || 'Неверно указан номер счета']"
                    color="secondary"
                    label="Р/с"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
              </v-row>
            </form>
          </v-tab-item>
          <v-tab-item>
            <form>
              <v-row>
                <v-col cols="4">
                  <v-text-field
                    v-model="form.insurer_contract"
                    label="Номер убытка"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="form.insurer_act"
                    label="Номер акта"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="form.insurer_other"
                    label="Прочий идентификатор СК"
                    class="purple-input"
                    :disabled="view"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="8">
                  <v-select
                    :items="select.refund_type"
                    v-model="form.refund_type"
                    :disabled="view"
                    />
                </v-col>
                <v-col cols="4">
                  <v-select
                    v-if="form.refund_type == 1"
                    v-model="form.service"
                    :items="select.services.filter(a=>a.data.auth == 1)"
                    label="Автосервис"
                    @change="choose_service"
                  />
                  </v-col>
              </v-row>
              <v-row v-if="form.refund_type == 1 || form.refund_type == 2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.service_requisites.name"
                      name="recipient_name"
                      label="Наименование получателя"
                    />
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="form.service_requisites.inn"
                      name="recipient_inn"
                      label="ИНН"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="form.service_requisites.kpp"
                      name="recipient_kpp"
                      label="КПП"
                    />
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="form.service_requisites.bank_name"
                      name="recipient_bank_name"
                      label="Банк"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="form.service_requisites.bic"
                      name="recipient_bic"
                      label="БИК"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.service_requisites.ks"
                      label="К/с"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.service_requisites.rs"
                      :counter="20"
                      label="Р/с"
                      :rules="[(v) => validateServiceRs() || 'Неверно указан номер счета']"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.service_requisites.description"
                      label="Назначение"
                    />
                  </v-col>
              </v-row>
            </form>
          </v-tab-item>
        </base-material-tabs>
        <v-row>
          <v-col
            cols="12"
            md="7"
          >
            <v-btn
              v-if="!create"
              :disabled="load"
              min-width="100"
              color="secondary"
              @click="$router.push('/contract/list')"
            >
              Назад
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-checkbox
              v-if="!create"
              v-model="form.generate_files"
              :disabled="load"
              label="Перегенерировать файлы?"
            />
          </v-col>
          <v-col
            cols="12"
            md="2"
            class="text-right"
          >
            <v-btn
              v-if="!create"
              :disabled="load"
              min-width="100"
              color="primary"
              @click="save(!create)"
            >
              Сохранить
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            md="2"
            class="text-right"
          >
            <v-btn
              v-if="create"
              min-width="100"
              color="primary"
              :disabled="load"
              @click="create_contract"
            >
              Создать
            </v-btn>
          </v-col>
        </v-row>
      </base-material-card>
    </v-col>
    <v-col
        v-if="view"
        cols="12"
        md="6"
      >
        <base-material-card
          class="v-card-profile"
          title="События"
        >
          <v-card-text>
            <div
              v-for="(item,index) in events"
              :key="index"
              style="cursor: pointer"
            >
              <event-form
                v-if="index == active"
                :create="false"
                :view="false"
                :change="true"
                :data="item"
                :show="true"
                :short="true"
                @close="load_events()"
              />
              <v-row v-else  @click="active = index" class="select_row">
                <v-col cols="2">
                  <v-icon large :color="item.color">{{ $store.state.dict.events[item.type].icon }}</v-icon>
                </v-col>
                <v-col cols="4">
                  <font :color="item.color">{{ $store.state.dict.events[item.type].name }} {{ item.start }}<br></font>
                  <font color="#db7093"><span v-if="item.user">{{ item.user_item.surname }} {{ item.user_item.name }} {{ item.user_item.patronymic }}</span><br></font>
                  <b>{{dict.state[item.state]}}</b>
                  
                </v-col>
                <v-col cols="6">
                  <font color="blue">{{item.text}}</font>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              min-width="100"
              @click="showCreateEvent"
            >
              Создать
            </v-btn>
          </v-card-actions>
        </base-material-card>
        <base-material-card
          color="success"
          class="v-card-profile"
          title="Комментарии"
        >
          <v-card-text>
            <v-data-table
              :items="comments"
              :headers="headers.comment"
              hide-default-header
              :footerProps="datatable_footer"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
              {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
              </template>
              <template v-slot:item.created="{item}">
                {{item.created}}<br>
                <font color="#db7093">{{item.creator_name}}</font>
              </template>
              <template v-slot:item.text="{item}">
                <font color="blue">{{item.text}}</font>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="8">
                <v-text-field
                  v-model="comment"
                  label="Введите комментарий"
                />
              </v-col>
              <v-col cols="4">
                <v-btn
                  :disabled="!comment || comment.length == 0"
                  color="primary"
                  @click="create_comment"
                >
                  <span class="mx-5">Добавить</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </base-material-card>
      </v-col>

    <v-dialog
      v-model="dialog.event.show"
      scrollable
      persistent
    >
      <event-form
        :create="dialog.event.create"
        :view="dialog.event.view"
        :change="dialog.event.change"
        :data="dialog.event.data"
        :show="dialog.event.show"
        @close="dialog.event.show = false, load()"
      />
    </v-dialog>
  </v-row>
</template>

<script>
  import EventForm from './EventForm'
  import $ from 'jquery'
  //import suggest from '../../libs/suggestions.min.17.12.0.dev.js'
  import suggest from 'suggestions-jquery'
  import moment from 'moment'
  export default {
    name: 'DashboardFormsWizard',
    components: { EventForm },
    props: ['create', 'id', 'contractId', 'kind', 'view', 'change'],
    data: () => ({
      datatable_footer: {
          itemsPerPageText: 'Показывать по', pageText: 'из',
          itemsPerPageAllText: 'Все'
        },
      active: 0,
      comment: '',
      comments: [],
      headers: {
          comment: [
            {
              value: 'created'
            },
            {
              value: 'text'
            }
          ]
        },
      table: {
        headers: [
          {
            text: 'Дата',
            value: 'date',
            width: 150,
          },
          {
            text: 'Тип',
            value: 'type',
          },
          {
            text: 'Тема',
            value: 'theme',
          },
          { text: '',
            value: 'action' },
        ],
      },
      dialog: {
        event: {
          show: false,
          item: {},
        },
      },
      events: [

      ],
      select: {
        services: [],
        requisites: [],
        refund_type: [
          {
            value: 0, text: 'По договору цессии'
          },
          {
            value: 1, text: 'Ремонт в авторизованном сервисе СК'
          },
          {
            value: 2, text: 'Оплата восстановительного ремонта в сервисе клиента'
          }
        ],
        state: [
          { value: 1, text: 'Новый' },
          { value: 2, text: 'Завершен' },
          { value: 3, text: 'Отменен' },
        ],
        type: [],
        clients: []
      },
      load: false,
      form: {
        refund_type: 0,
        service_requisites: {},
        accident: '',
        date: '',
        number: '',
        type: 0,
        former: 0,
        scheme: {
          series: '',
          number: '',
          date: '',
        },
        sum: 0,
        percent: 20,
        state: 1,
        owner: {
          surname: '',
          name: '',
          patronymic: '',
          address: '',
          birthday: '',
          doc_type: 1,
          doc: {
            series: '',
            number: '',
            date: '',
            from: '',
          },
          requisites: {
            bic: '',
            bank_name: '',
            ks: '',
            rs: '',
          },
        },
        insurer: 0,
        kind: 1,
      },
      dict: {
        category: [
          { value: 1, text: 'A' },
          { value: 2, text: 'B' },
          { value: 3, text: 'C' },
          { value: 4, text: 'D' },
          { value: 5, text: 'E' },
        ],
        insurer: [],
        circumstances: [],
        doc_type: [
          { value: 1, text: 'Паспорт' },
        ],
        contract_type: [
          { value: 1, text: 'Извещение' },
          { value: 2, text: 'Схема' },
        ],
        scheme_former: [
          { value: 1, text: 'ГИБДД' },
          { value: 2, text: 'Евроком' },
          { value: 3, text: 'Другие' },
        ],
        kind: [
          { value: 1, text: 'Оформление документов' },
          { value: 2, text: 'Договор Цессии' },
          { value: 3, text: 'Договор юр. услуг' },
        ],
        state: {
          1: 'Новый',
          2: 'Завершен',
          3: 'Отменен',
        },
      },
      tab: 0,
      tabs: ['Основное', 'Клиент', 'Документы', 'Реквизиты', 'Данные СК'],
      suggestion: {},
      suggestion2: false,
      suggestion3: false,
      suggestion4: false
    }),

    computed: {
      title: function () {
        if (this.create) return 'Создание'
        if (this.view) return 'Просмотр'
        if (this.change) return 'Изменение'
      },
      stringAccount () {
        return this.account.join(',')
      },
      scope () {
        if (this.tab === 0) return 'common'
        if (this.tab === 1) return 'first_vehicle'
        if (this.tab === 2) return 'first_owner'
        if (this.tab === 3) return 'first_driver'
        if (this.tab === 4) return 'first_insurance'
        if (this.tab === 5) return 'first_common'
        if (this.tab === 6) return 'second_vehicle'
        if (this.tab === 7) return 'second_owner'
        if (this.tab === 8) return 'second_driver'
        if (this.tab === 9) return 'second_insurance'
        if (this.tab === 10) return 'second_common'
      },
      availableSteps () {
        const steps = [0]
        console.log('ava')
        if (this.form.date) {
          if (this.form.type == 1) steps.push(1)
          if (this.form.type == 2 && this.form.scheme.series && this.form.scheme.number && this.form.scheme.date && this.form.former) steps.push(1)
        }

        if (steps.includes(1)) {
          if (this.form.owner.surname && this.form.owner.name && this.form.owner.birthday && this.form.owner.address) steps.push(2)
        }

        if (steps.includes(2)) {
          if (this.form.owner.doc_type && this.form.owner.doc.series && this.form.owner.doc.number && this.form.owner.doc.date) steps.push(3)
        }

        if (steps.includes(3)) {
          // if (this.form.owner.requisites.bank_name && this.form.owner.requisites.bic && this.form.owner.requisites.rs) steps.push(4)
          steps.push(4)
        }
        if (steps.includes(4)) {
          // if (this.form.owner.requisites.bank_name && this.form.owner.requisites.bic && this.form.owner.requisites.rs) steps.push(4)
          steps.push(5)
        }
        return steps
      },
    },
    watch: {
      watch: {
      'form.service_requisites.bank_name': function () {
        if (!this.suggestion.bank_name && $('[name=recipient_bank_name]').length > 0) {
          this.suggestion.bank_name = true
          $('[name=recipient_bank_name]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              this.form.service_requisites.bank_name = data.data.name.full || data.data.name.payment
              this.form.service_requisites.bic = data.data.bic
              this.form.service_requisites.ks = data.data.correspondent_account
            },
          })
        }
      },
      'form.service_requisites.bic': function () {
        if (!this.suggestion.bic && $('[name=recipient_bic]').length > 0) {
          this.suggestion.bic = true
          $('[name=recipient_bic]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              this.form.service_requisites.bank_name = data.data.name.full || data.data.name.payment
              this.form.service_requisites.bic = data.data.bic
              this.form.service_requisites.ks = data.data.correspondent_account
            },
          })
        }
      },
      'form.service_requisites.inn': function () {
        if (!this.suggestion.inn && $('[name=recipient_inn]').length > 0) {
          this.suggestion.inn = true
          $('[name=recipient_inn]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              this.form.service_requisites.name = data.data.name.full
              this.form.service_requisites.inn = data.data.inn
              this.form.service_requisites.kpp = data.data.kpp
            },
          })
        }
      },
      'form.service_requisites.name': function () {
        if (!this.suggestion.name && $('[name=recipient_name]').length > 0) {
          this.suggestion.name = true
          $('[name=recipient_name]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              this.form.service_requisites.name = data.data.name.full
              this.form.service_requisites.inn = data.data.inn
              this.form.service_requisites.kpp = data.data.kpp
            },
          })
        }
      },
      'form.service_requisites.kpp': function () {
        if (!this.suggestion.kpp && $('[name=recipient_kpp]').length > 0) {
          this.suggestion.kpp = true
          $('[name=recipient_kpp]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              this.form.service_requisites.name = data.data.name.full
              this.form.service_requisites.inn = data.data.inn
              this.form.service_requisites.kpp = data.data.kpp
            },
          })
        }
      },
    },
      'form.service_requisites.bank_name': function () {
        if (!this.suggestion.bank_name && $('[name=recipient_bank_name]').length > 0) {
          this.suggestion.bank_name = true
          $('[name=recipient_bank_name]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              this.form.service_requisites.bank_name = data.data.name.full || data.data.name.payment
              this.form.service_requisites.bic = data.data.bic
              this.form.service_requisites.ks = data.data.correspondent_account
            },
          })
        }
      },
      'form.service_requisites.bic': function () {
        if (!this.suggestion.bic && $('[name=recipient_bic]').length > 0) {
          this.suggestion.bic = true
          $('[name=recipient_bic]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              this.form.service_requisites.bank_name = data.data.name.full || data.data.name.payment
              this.form.service_requisites.bic = data.data.bic
              this.form.service_requisites.ks = data.data.correspondent_account
            },
          })
        }
      },
      'form.service_requisites.inn': function () {
        if (!this.suggestion.inn && $('[name=recipient_inn]').length > 0) {
          this.suggestion.inn = true
          $('[name=recipient_inn]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              this.form.service_requisites.name = data.data.name.full
              this.form.service_requisites.inn = data.data.inn
              this.form.service_requisites.kpp = data.data.kpp
            },
          })
        }
      },
      'form.service_requisites.name': function () {
        if (!this.suggestion.name && $('[name=recipient_name]').length > 0) {
          this.suggestion.name = true
          $('[name=recipient_name]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              this.form.service_requisites.name = data.data.name.full
              this.form.service_requisites.inn = data.data.inn
              this.form.service_requisites.kpp = data.data.kpp
            },
          })
        }
      },
      'form.service_requisites.kpp': function () {
        if (!this.suggestion.kpp && $('[name=recipient_kpp]').length > 0) {
          this.suggestion.kpp = true
          $('[name=recipient_kpp]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              this.form.service_requisites.name = data.data.name.full
              this.form.service_requisites.inn = data.data.inn
              this.form.service_requisites.kpp = data.data.kpp
            },
          })
        }
      },
      'form.owner.requisites.bank_name': function () {
        if (!this.suggestion1 && $('[name=bank_name]').length > 0) {
          this.suggestion1 = true
          $('[name=bank_name]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              this.form.owner.requisites.bank_name = data.data.name.full || data.data.name.payment
              this.form.owner.requisites.bic = data.data.bic
              this.form.owner.requisites.ks = data.data.correspondent_account
            },
          })
        }
      },
      'form.owner.requisites.bic': function () {
        if (!this.suggestion2 && $('[name=bank_bic]').length > 0) {
          this.suggestion2 = true
          $('[name=bank_bic]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              this.form.owner.requisites.bank_name = data.data.name.full || data.data.name.payment
              this.form.owner.requisites.bic = data.data.bic
              this.form.owner.requisites.ks = data.data.correspondent_account
            },
          })
        }
      },
    },
    mounted: function () {
      this.axios.post('/api/clients/list/', {
        agent: true
      })
        .then(response => {
          if (!response.data.error) {
            if (this.select.clients[0]) {
              let owner = this.select.clients[0]
              this.select.clients = response.data.data
              this.select.clients.push(owner)
            } else {
              this.select.clients = response.data.data
            }
            console.log(this.form.commissar)
          } else {

          }
        })
        .catch(e => {
          console.log(e)
        })
      for (let x in this.$store.state.dict.services) {
        this.select.services.push({ value: Number(x), text: this.$store.state.dict.services[x].name, data: this.$store.state.dict.services[x] })
      }
      for (let x in this.$store.state.dict.requisites) {
        if (this.$store.state.dict.requisites[x].archive != '1')
          this.select.requisites.push({ value: Number(x), text: this.$store.state.dict.requisites[x].bank + '\\' + this.$store.state.dict.requisites[x].rs })
      }
      console.log('requisites', this.select.requisites)
      for (let x in this.$store.state.dict.events) {
        this.select.type.push({
          value: Number(x),
          text: this.$store.state.dict.events[x].name,
        })
      }
      for (let x in this.$store.state.dict.insurer) {
        this.dict.insurer.push({ value: Number(x), text: this.$store.state.dict.insurer[x].name })
      }
      for (let x in this.$store.state.dict.circumstances) {
        this.dict.circumstances.push({ value: x, text: this.$store.state.dict.circumstances[x].name })
      }
      for (let x in this.$store.state.dict.insurer) {
        this.dict.insurer.push({ value: x, text: this.$store.state.dict.insurer[x].name })
      }
      if (this.create) {
        this.form = {
          city: '',
          service_requisites: {},
          accident: '',
          date: moment().format('YYYY-MM-DD'),
          number: '',
          type: 0,
          former: 0,
          scheme: {
            series: '',
            number: '',
            date: moment().format('YYYY-MM-DD'),
          },
          sum: 0,
          state: 1,
          percent: 20,
          owner: {
            surname: '',
            name: '',
            patronymic: '',
            address: '',
            birthday: '',
            doc_type: 1,
            doc: {
              series: '',
              number: '',
              date: '',
              from: '',
            },
            requisites: {
              bic: '',
              bank_name: '',
              ks: '',
              rs: '',
            },
            insurer: 0,
            kind: this.kind || 1,
          },
        }
        if (this.$store.state.client && this.$store.state.client.cities) {
          if (this.$store.state.client.cities.length == 1) {
            this.form.city = this.$store.state.client.cities[0]
          } else {
            for (let x in this.$store.state.client.cities) {
              let city = this.$store.state.client.cities[x]
              if (city == 'Уфа') {
                this.form.city = this.$store.state.client.cities[x]
              }
            }
          }
        }
        if (this.$route.params.id) {
          this.axios.post('/api/accident/get', { id: this.$route.params.id })
            .then(result => {
              if (!result.data.error) {
                if (result.data.data.length == 0) this.$router.push('/accident-list')
                this.form.accident = this.$route.params.id
                this.form.insurer = Number(result.data.data[0].first.insurance.insurer)
                this.form.kind = this.kind || 1
                this.load_comments()
                this.axios.post('/api/common/driver/get', { id: result.data.data[0].first.owner.id })
                  .then(result => {
                    if (!result.data.error) {
                      this.form.owner = result.data.data
                      this.form.owner.birthday = moment(this.form.owner.birthday).format('YYYY-MM-DD')

                      this.form.owner.doc = this.form.owner.doc || {
                        series: '',
                        number: '',
                        date: '',
                        from: '',
                      }
                      this.form.owner.doc.date = moment(this.form.owner.doc.date).format('YYYY-MM-DD')
                      this.form.owner.requisites = this.form.owner.requisites || {
                        bic: '',
                        bank_name: '',
                        ks: '',
                        rs: '',
                      }
                      let owner = JSON.parse(JSON.stringify(this.form.owner))
                      owner.insurer_agent = true
                      owner.surname = "Собственник ТС"
                      owner.name = ""
                      owner.patronymic = ""
                      
                      this.select.clients.push(owner)
                      if (this.form.kind == 3) {
                        this.form.insurer_agent = owner.id
                      }
                      
                    }
                  })
              }
            })
        } else {
          this.$router.push('/accident-list')
        }
      } else {
        this.axios.post('/api/contract/get', { id: this.$route.query.id })
          .then(result => {
            if (!result.data.error) {
              this.form = result.data.data[0]
              this.form.date = moment(this.form.date).format('YYYY-MM-DD')
              console.log(this.form)
              this.form.scheme.date = moment(this.form.scheme.date).format('YYYY-MM-DD')
              this.form.owner.doc.date = moment(this.form.owner.doc.date).format('YYYY-MM-DD')
              if (this.form.protocol_date) this.form.protocol_date = moment(this.form.protocol_date).format('YYYY-MM-DD')
              this.form.owner.birthday = moment(this.form.owner.birthday).format('YYYY-MM-DD')
              this.form.service_requisites = this.form.service_requisites || {}
              this.load_comments()
              let owner = JSON.parse(JSON.stringify(this.form.owner))
              owner.insurer_agent = true
              owner.surname = "Собственник ТС"
              owner.name = ""
              owner.patronymic = "" 
              this.select.clients.push(owner)
            }
          })
        this.axios.post('/api/event/list', {
          contract: this.$route.query.id,
        })
          .then(result => {
            if (!result.data.error) {
              for (let x in result.data.data) {
                result.data.data[x].color = this.$store.state.dict.events[result.data.data[x].type].color
                result.data.data[x].start = moment(result.data.data[x].date).format('DD.MM.YYYY') + ' ' + String(result.data.data[x].time).substring(0, 5)
                result.data.data[x].end = moment(result.data.data[x].date).format('YYYY-MM-DD') + ' ' + String(result.data.data[x].time).substring(0, 5)
                result.data.data[x].name = this.$store.state.dict.events[result.data.data[x].type].name
              }
              this.events = result.data.data
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      }
    },
    methods: {
      choose_service: function () {
        this.form.service_requisites = this.select.services.filter(a => a.value == this.form.service)[0].data
      },
      create_comment: function() {
        this.$axios.post('/api/comment/create', {
          text: this.comment,
          entity: this.form.id
        })
        .then(response=> {
          if (!response.data.error) {
            this.comment = ""
            this.$store.commit('snackbar', 'Успешно')
            this.load_comments()
          } else {
            this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
          }
        })
        .catch(e => {
          this.$store.commit('snackbar', 'Ошибка при сохранении данных')
        })
      },
      load_comments: function () {
        this.axios.post('/api/comment/list', {
          entity: this.form.id,
        })
          .then(result => {
            if (!result.data.error) {
              for (let x in result.data.data) {
                result.data.data[x].created = moment(result.data.data[x].created).format('DD.MM.YYYY HH:mm:ss')
                result.data.data[x].creator_name = (result.data.data[x].creator.surname || "") + " " + (result.data.data[x].creator.name || "") + " " + (result.data.data[x].creator.patronymic || "")
              }
              this.comments = result.data.data
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      doc_code_input: function() {
        if (!this.suggestion3) {
          if (!this.suggestion3 && $('[name=doc_code]').length > 0) {
            this.suggestion3 = true
            $('[name=doc_code]').suggestions({
              token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
              type: 'fms_unit',
              count: 5,
              onSelect: data => {
                this.form.owner.doc.code = data.data.code
                this.form.owner.doc.from = data.data.name
              },
            })
          }
        }
      },
      doc_from_input: function() {
        if (!this.suggestion4) {
          if (!this.suggestion4 && $('[name=doc_from]').length > 0) {
            this.suggestion4 = true
            $('[name=doc_from]').suggestions({
              token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
              type: 'fms_unit',
              count: 5,
              onSelect: data => {
                this.form.owner.doc.code = data.data.code
                this.form.owner.doc.from = data.data.name
              },
            })
          }
        }
      },
      check_user: function(id) {
        var user = this.select.clients.filter(a=>a.id == id)[0]
        console.log(moment(user.agent_doc.date).diff(moment(), 'days'))
        if (user.agent_doc.type == 2 && moment(user.agent_doc.date).diff(moment(), 'days') < 0) {
          alert('Срок действия доверенности данного представителя истек (' + moment(user.agent_doc.date).format('DD.MM.YYYY') + ')')
        }
      },
      format_contract: function (number, date) {
        return number + '/' + moment(date).format('DDMM')
      },
      showEvent: function (event) {
        this.dialog.event.data = event
        this.dialog.event.show = true
        this.dialog.event.create = false
        this.dialog.event.change = true
        this.dialog.event.view = false
      },
      showCreateEvent: function (event) {
        this.dialog.event.data = {
          contract: this.form.id,
          accident: this.form.accident,
        }
        this.dialog.event.show = true
        this.dialog.event.create = true
        this.dialog.event.change = false
        this.dialog.event.view = false
      },
      validateRs: function () {
        let error = {}
        let rs = this.form.owner.requisites.rs
        let bik = this.form.owner.requisites.bic
        var result = false
        if (typeof rs === 'number') {
          rs = rs.toString()
        } else if (typeof rs !== 'string') {
          rs = ''
        }
        if (!rs.length) {
          error.code = 1
          error.message = 'Р/С пуст'
        } else if (/[^0-9]/.test(rs)) {
          error.code = 2
          error.message = 'Р/С может состоять только из цифр'
        } else if (rs.length !== 20) {
          error.code = 3
          error.message = 'Р/С может состоять только из 20 цифр'
        } else {
          var bikRs = bik.toString().slice(-3) + rs
          var checksum = 0
          var coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1]
          for (var i in coefficients) {
            checksum += coefficients[i] * (bikRs[i] % 10)
          }
          if (checksum % 10 === 0) {
            result = true
          } else {
            error.code = 4
            error.message = 'Неправильное контрольное число'
          }
        }
        return result
      },
      validateServiceRs: function () {
        let error = {}
        let rs = this.form.service_requisites.rs
        let bik = this.form.service_requisites.bic
        var result = false
        if (typeof rs === 'number') {
          rs = rs.toString()
        } else if (typeof rs !== 'string') {
          rs = ''
        }
        if (!rs.length) {
          error.code = 1
          error.message = 'Р/С пуст'
        } else if (/[^0-9]/.test(rs)) {
          error.code = 2
          error.message = 'Р/С может состоять только из цифр'
        } else if (rs.length !== 20) {
          error.code = 3
          error.message = 'Р/С может состоять только из 20 цифр'
        } else {
          var bikRs = bik.toString().slice(-3) + rs
          var checksum = 0
          var coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1]
          for (var i in coefficients) {
            checksum += coefficients[i] * (bikRs[i] % 10)
          }
          if (checksum % 10 === 0) {
            result = true
          } else {
            error.code = 4
            error.message = 'Неправильное контрольное число'
          }
        }
        return result
      },
      save: function (stay) {
        this.load = true
        // this.form.id = this.$route.params.id
        this.axios.post('/api/contract/update', this.form)
          .then(result => {
            this.load = false
            if (!result.error) {
              this.$store.commit('snackbar', 'Сохранение успешно')
              if (!stay) { this.$router.push('/contract/list') }
            } else {
              this.$store.commit('snackbar', 'Ошибка при сохранении')
            }
          })
          .catch(error => {
            this.load = false
            this.$store.commit('snackbar', 'Ошибка при сохранении')
          })
      },
      create_contract () {
        this.load = true
        this.axios.post('/api/contract/create', this.form)
          .then(result => {
            this.load = false
            if (!result.error) {
              this.$store.commit('snackbar', 'Создание успешно')
              this.$router.push('/contract/list')
            } else {
              this.$store.commit('snackbar', 'Ошибка при создании')
            }
          })
          .catch(error => {
            this.load = false
            this.$store.commit('snackbar', 'Ошибка при создании')
          })
      },
      onChange (val) {
        const value = val.target.files[0]

        if (!value) return (this.image = null)

        this.image = URL.createObjectURL(value)
      },
      validateForm (scope) {
        return this.$validator.validateAll(scope)
      },
    },
  }
</script>

<style lang="sass">
  .v-card.v-card.v-card--account
    border-color: currentColor
    border-width: 4px

    .v-icon
      color: inherit

  .v-card--account,
  .v-card--account:before
    border-radius: 50%

</style>
